import { render, staticRenderFns } from "./buyers.vue?vue&type=template&id=7b6b0972&scoped=true"
import script from "./buyers.vue?vue&type=script&lang=js"
export * from "./buyers.vue?vue&type=script&lang=js"
import style0 from "./buyers.vue?vue&type=style&index=0&id=7b6b0972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b0972",
  null
  
)

export default component.exports